import React, { useState } from "react";
import { auth } from "../services/auth";
import { Helmet } from "react-helmet";
import { useAuth } from "../services/AuthProvider";
import { updateUser } from "../services/settings";
import styles from "../css/settings.module.css";
import Loader from "../shared/Loader";

export default function Settings() {
  const user = auth().getUser();
  const { setAuth, user1 } = useAuth();
  const [name, setName] = useState(user ? `${user.firstName}` : "");
  const [lastName, setLastName] = useState(user ? `${user.lastName}` : "");
  const [email, setEmail] = useState(user ? user.email : "");
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorList, setErrorList] = useState([]);
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const token = auth().getToken();
  const authTemp = useAuth().auth;
  const inputs = {
    firstName: name,
    lastName,
    email,
    currentPassword,
    password,
    confirmPassword,
  };

  const [errors, setErrors] = useState({
    name: true,
    lastName: true,
    email: true,
    currentPassword: true,
    passwordsMatch: true,
  });

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  let isValid = false;

  const handleValidation = () => {
    let field = true;
    if (currentPassword?.length > 0 || password?.length > 0 || confirmPassword?.length > 0) {
      setErrorList([]);
      if (
        password === "" ||
        password === undefined ||
        password === null ||
        password !== confirmPassword
      ) {
        setErrorList((errorList) => [...errorList, "Confirm password is Not Matched"]);
        isValid = false;
        setHasError(true);
        setSuccess(false);
      } else {
        if (currentPassword?.length === 0) {
          setErrorList((errorList) => [...errorList, "Current password missing!"]);
          isValid = false;
          setHasError(true);
          setSuccess(false);
          field = false;
        } else {
          isValid = true;
          field = true;
          setHasError(false);
        }
      }
    }
    if (currentPassword?.length === 0 && password?.length === 0 && confirmPassword?.length === 0) {
      isValid = true;
      setHasError(false);
    }
    validateFields(name, lastName, email, field, field);
  };

  const validateFields = (name, lastName, email, currentPassword, passwordsMatch) => {
    setErrors({
      name: name?.length > 0,
      lastName: lastName?.length > 0,
      email: email?.length > 0,
      currentPassword: currentPassword,
      passwordsMatch: passwordsMatch,
    });
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    setErrorList("");
    handleValidation();

    if (!name || !lastName || !email) {
      setErrorList((errorList) => [...errorList, "Missing field"]);
      return;
    }

    if (isValid) {
      return await updateUser(user, inputs, config)
        .then((response) => {
          if (response.status === 200) {
            auth().updateUser(response.data.returnClass);
            setErrorList((errorList) => [...errorList, "User Updated!"]);
            setAuth(!authTemp);
            setSuccess(true);
            setHasError(false);
            return response.data;
          }
          if (response.status === 400) {
            setErrorList((errorList) => [...errorList, response.message]);
            setHasError(true);
            setSuccess(false);
          }
          return response.data;
        })
        .catch((error) => {
          setHasError(true);
          setSuccess(false);
          setErrorList((errorList) => [...errorList, error?.response?.data?.message]);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <section className="flex flex-col my-20 px-3 md:px-5 lg:px-5 items-center lg:items-start">
      <Helmet>
        <title>Dailysocialboost | Account</title>
      </Helmet>
      <h2 className="text-xl font-bold my-5">Account Settings</h2>
      <div className="flex flex-row  gap-5 my-5 ">
        <div>
          <form onSubmit={handleUpdate}>
            <div className="my-5">
              <p>
                <label className="uppercase font-semibold" htmlFor="name">
                  Name
                </label>
              </p>
              <input
                className={`h-8 w-full ${styles.settingsInput}`}
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                name="name"
                id="name"
                required
              />
              {!errors?.name ? <p className="text-red-600">This field is required!</p> : null}
            </div>
            <div className="my-5">
              <p>
                <label className="uppercase font-semibold" htmlFor="lastName">
                  Last Name
                </label>
              </p>
              <input
                className={`h-8 w-full ${styles.settingsInput}`}
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                name="lastName"
                id="lastName"
                required
              />
              {!errors?.lastName ? <p className="text-red-600">This field is required!</p> : null}
            </div>
            <div className="my-5">
              <p>
                <label className="uppercase font-semibold" htmlFor="email">
                  Email Address
                </label>
              </p>
              <input
                className={`h-8 w-full ${styles.settingsInput}`}
                type="email"
                disabled
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                name="email"
                id="email"
                required
              />
              {!errors?.email ? <p className="text-red-600">This field is required!</p> : null}
            </div>
            <div className="my-5">
              <p>
                <label className="uppercase font-semibold" htmlFor="currentPassword">
                  Current Password
                </label>
              </p>
              <input
                className={`h-8 w-full ${styles.settingsInput}`}
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                name="currentPassword"
                id="currentPassword"
                required
              />
              {!errors?.currentPassword ? (
                <p className="text-red-600">This field is required!</p>
              ) : null}
            </div>
            <div className="my-5">
              <p>
                <label className="uppercase font-semibold" htmlFor="password">
                  New Password
                </label>
              </p>
              <input
                className={`h-8 w-full ${styles.settingsInput}`}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                name="password"
                id="password"
              />
              {!errors?.passwordsMatch ? (
                <p className="text-red-600">This field is required!</p>
              ) : null}
            </div>
            <div className="my-5">
              <p>
                <label className="uppercase font-semibold" htmlFor="confirmPassword">
                  Confirm New Password
                </label>
              </p>
              <input
                className={`h-8 w-full ${styles.settingsInput}`}
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                name="confirmPassword"
                id="confirmPassword"
              />
              {!errors?.passwordsMatch ? (
                <p className="text-red-600">This field is required!</p>
              ) : null}
            </div>
            <div className="text-red-600">
              <div>
                <div
                  className={`flex flex-col ${
                    isLoading ? "justify-center" : hasError ? "justify-center" : "justify-center"
                  }`}
                >
                  {isLoading ? (
                    <div className="my-5 mx-20">
                      {" "}
                      <Loader styles={"w-12 h-12"}></Loader>{" "}
                    </div>
                  ) : hasError ? (
                    errorList != null ? (
                      errorList?.map((item, idx) => (
                        <div
                          key={Math.random()}
                          className="flex p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
                          role="alert"
                        >
                          <svg
                            aria-hidden="true"
                            className="flex-shrink-0 inline w-5 h-5 mr-3"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                          <div>
                            <span className="font-medium">Error!</span> {item}
                          </div>
                        </div>
                      ))
                    ) : null
                  ) : null}
                </div>
                {success ? (
                  <div
                    className="flex p-4 mb-4 text-sm text-white rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400"
                    role="alert"
                  >
                    <svg
                      aria-hidden="true"
                      className="flex-shrink-0 inline w-5 h-5 mr-3"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    <div>
                      <span className="font-medium">Success! </span> Sucessfully updated user!
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <input
              onClick={handleUpdate}
              className="my-5 px-20 py-2 uppercase font-semibold rounded-3xl border-2 border-pink-350 hover:text-pink-350"
              type="submit"
              value="Update"
            />
          </form>
        </div>
      </div>
    </section>
  );
}
